<ng-container *transloco="let t">
  <div>
    <nz-page-header class="bg-slate-100" [nzGhost]="false">
      <nz-page-header-title class="max-[563px]:w-64 text-primary flex items-center gap-2">
        {{ t('otherContent.title') }}
        <nz-icon
          nz-tooltip
          nzTooltipPlacement="right"
          [nzTooltipArrowPointAtCenter]="true"
          [nzTooltipTitle]="'nav.featureTooltips.other' | transloco"
          [nzTooltipOverlayStyle]="{
            'max-width': '400px',
            'min-width': '300px',
            'white-space': 'normal',
            'line-height': '1.5'
          }"
          nzType="info-circle"
          nzTheme="outline">
        </nz-icon>
      </nz-page-header-title>
    </nz-page-header>
  </div>

  <div class="my-4">
    <div class="flex justify-between items-center">
      <div class="flex items-center gap-2">
        <label>{{ t('otherContent.languageLabel') }}</label>
        <nz-select
          [(ngModel)]="this.language"
          (ngModelChange)="this.onChangeLanguage($event)"
          [ngModelOptions]="{ standalone: true }">
          <nz-option
            *ngFor="let lang of getSelectedLanguagesObjectArray()"
            [nzValue]="lang?.code"
            [nzLabel]="lang?.name"></nz-option>
        </nz-select>
      </div>

      <div class="flex items-center gap-2">
        <ng-container *ngIf="language !== 'en'">
          <span *ngIf="hasEnglishContent()" class="text-md">
            {{ t('otherContent.populateEnglishHint') }}
          </span>

          <button
            *ngIf="hasEnglishContent()"
            nz-button
            nzType="default"
            class="flex items-center"
            (click)="useEnglishContent()">
            {{ t('otherContent.useEnglishContent') }}
          </button>

          <button
            *ngIf="contentId !== undefined && activeTabIndex === 0"
            class="ai-button flex items-center"
            nz-button
            nzType="default"
            [disabled]="!this.otherContentForm.get('inclusions')?.value"
            (click)="translateContent(this.otherContentForm.get('inclusions')?.value, this.language, 'inclusions')">
            <span nz-icon nzType="plus"></span>
            {{ t('otherContent.translateBtn') }}
          </button>

          <button
            *ngIf="contentId !== undefined && activeTabIndex === 1"
            class="ai-button flex items-center"
            nz-button
            nzType="default"
            [disabled]="!this.otherContentForm.get('exclusions')?.value"
            (click)="translateContent(this.otherContentForm.get('exclusions')?.value, this.language, 'exclusions')">
            <span nz-icon nzType="plus"></span>
            {{ t('otherContent.translateBtn') }}
          </button>

          <button
            *ngIf="contentId !== undefined && activeTabIndex === 2"
            class="ai-button flex items-center"
            nz-button
            nzType="default"
            [disabled]="!this.otherContentForm.get('policies')?.value"
            (click)="translateContent(this.otherContentForm.get('policies')?.value, this.language, 'policies')">
            <span nz-icon nzType="plus"></span>
            {{ t('otherContent.translateBtn') }}
          </button>
        </ng-container>
      </div>
    </div>

    <form [formGroup]="otherContentForm">
      <nz-tabset [nzAnimated]="false" (nzSelectChange)="onTabChange($event)">
        <nz-tab [nzTitle]="t('otherContent.tabs.inclusions')">
          <quill-editor
            class="w-full h-96"
            formControlName="inclusions"
            [placeholder]="t('otherContent.placeholders.inclusions')">
            <div quill-editor-toolbar>
              <div class="ql-formats">
                <button class="ql-bold"></button>
                <button class="ql-italic"></button>
              </div>
              <div class="ql-formats">
                <button class="ql-list" value="ordered"></button>
                <button class="ql-list" value="bullet"></button>
              </div>
            </div>
          </quill-editor>

          <div class="flex justify-end gap-5 mt-5" *appHasAnyPrivilege="'OTHER.CONTENT.UPDATE.INCLUSION'">
            <button
              *ngIf="contentId !== undefined"
              nz-button
              nzType="primary"
              (click)="createOrUpdateOtherContent('INCLU')">
              {{ t('otherContent.buttons.updateInclusions') }}
            </button>
            <button
              *ngIf="contentId === undefined"
              nz-button
              nzType="primary"
              (click)="createOrUpdateOtherContent('INCLU')">
              {{ t('otherContent.buttons.createInclusions') }}
            </button>
          </div>
        </nz-tab>

        <nz-tab [nzTitle]="t('otherContent.tabs.exclusions')">
          <quill-editor
            class="w-full h-96"
            formControlName="exclusions"
            [placeholder]="t('otherContent.placeholders.exclusions')">
            <div quill-editor-toolbar>
              <div class="ql-formats">
                <button class="ql-bold"></button>
                <button class="ql-italic"></button>
              </div>
              <div class="ql-formats">
                <button class="ql-list" value="ordered"></button>
                <button class="ql-list" value="bullet"></button>
              </div>
            </div>
          </quill-editor>

          <div class="flex justify-end gap-5 mt-5" *appHasAnyPrivilege="'OTHER.CONTENT.UPDATE.EXCLUSION'">
            <button
              *ngIf="contentId !== undefined"
              nz-button
              nzType="primary"
              (click)="createOrUpdateOtherContent('EXCLU')">
              {{ t('otherContent.buttons.updateExclusions') }}
            </button>
            <button
              *ngIf="contentId === undefined"
              nz-button
              nzType="primary"
              (click)="createOrUpdateOtherContent('EXCLU')">
              {{ t('otherContent.buttons.createExclusions') }}
            </button>
          </div>
        </nz-tab>

        <nz-tab [nzTitle]="t('otherContent.tabs.termsAndConditions')">
          <quill-editor
            class="w-full h-96"
            formControlName="policies"
            [placeholder]="t('otherContent.placeholders.policies')">
            <div quill-editor-toolbar>
              <div class="ql-formats">
                <button class="ql-bold"></button>
                <button class="ql-italic"></button>
              </div>
              <div class="ql-formats">
                <button class="ql-list" value="ordered"></button>
                <button class="ql-list" value="bullet"></button>
              </div>
            </div>
          </quill-editor>

          <div class="flex justify-end gap-5 mt-5" *appHasAnyPrivilege="'OTHER.CONTENT.UPDATE.CANCELLATION.POLICY'">
            <button
              *ngIf="contentId !== undefined"
              nz-button
              nzType="primary"
              (click)="createOrUpdateOtherContent('POLIC')">
              {{ t('otherContent.buttons.updatePolicies') }}
            </button>
            <button
              *ngIf="contentId === undefined"
              nz-button
              nzType="primary"
              (click)="createOrUpdateOtherContent('POLIC')">
              {{ t('otherContent.buttons.createPolicies') }}
            </button>
          </div>
        </nz-tab>
      </nz-tabset>

      <div>
        <nz-alert
          *ngIf="actionMessage.display && actionMessage.isAdd"
          class="mt-2"
          [nzType]="actionMessage.type"
          [nzMessage]="actionMessage.message"
          nzShowIcon
          nzCloseable></nz-alert>
      </div>
    </form>
  </div>
</ng-container>
